import { render, staticRenderFns } from "./AssetText.vue?vue&type=template&id=0f9d600c&"
import script from "./AssetText.vue?vue&type=script&lang=js&"
export * from "./AssetText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports